import { Routes } from '@angular/router';

import { HypeComponent } from '../../../Common/Layout/components/Hype/hype.component';
import { TargetingResultsComponent } from '../../Targeting/components/TargetingResults/targeting-results.component';


export const targetingListRoutes: Routes = [
    {
        path: '',
        component: HypeComponent,
        data: {title: 'Discover.lists.browserTitle'}
    },
    {
        path: 'list/:id/results',
        component: TargetingResultsComponent
    },
    {
        path: '**',
        redirectTo: '/Discover/targetinglists'
    }
];
